import React from "react";
import PropTypes from "prop-types";
import cancel from "assets/images/cancel.svg";

const FiltersHeader = ({ title = "Filters", onClear = undefined, onClose = undefined }) => (
	<header className="filters__header">
		<span className="filters__title">{title}</span>
		<div className="filters__actions">
			<button
				type="button"
				className="filters__clear-button"
				onClick={onClear}
			>
				Clear All
			</button>
			{onClose && (
				<button
					type="button"
					className="filters__close-button"
					onClick={onClose}
				>
					<img
						alt="cancel icon"
						src={cancel}
						width="20"
						height="20"
					/>
				</button>
			)}
		</div>
	</header>
);

FiltersHeader.propTypes = {
	title: PropTypes.string,
	onClear: PropTypes.func,
	onClose: PropTypes.func
};

export default FiltersHeader;
